module.exports = __webpack_public_path__ + "static/media/babel.4cdb519f.png";